import { Component, computed, inject, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { TextImageComponent } from '@content/ui/text-image';
import {
  TextField,
  ImageField,
  RichTextField,
  LinkField,
} from '@core/jss-proxy';
import { getField } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import { getAppStoreButton, getGooglePlayButton } from '@core/navigation-store';
import { AppStoreButtonsComponent } from '@core/navigation-ui';

@Component({
  selector: 'wl-text-image-container',
  templateUrl: './text-image.container.component.html',
  standalone: true,
  imports: [TextImageComponent, AppStoreButtonsComponent],
})
export class TextImageContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();

  readonly inverse = computed(
    () => this.rendering().params?.['ShowInverse'] === '1'
  );

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly content = computed(() =>
    getField<RichTextField>(this.fields(), 'content')
  );
  readonly image = computed(() => getField<ImageField>(this.fields(), 'image'));
  readonly primaryButton = computed(() =>
    getField<LinkField>(this.fields(), 'primaryButton')
  );
  readonly secondaryButton = computed(() =>
    getField<LinkField>(this.fields(), 'secondaryButton')
  );
  readonly microcopy = computed(() =>
    getField<TextField>(this.fields(), 'microcopy')
  );

  readonly showAppStoreButtons = computed(
    () => this.rendering().componentName === 'TextImageAppSection'
  );

  readonly #store = inject(Store);
  readonly appStoreButton = this.#store.selectSignal(getAppStoreButton);
  readonly googlePlayButton = this.#store.selectSignal(getGooglePlayButton);
}
